import React from 'react';
import styled from 'styled-components';

import Input from '../../../components/Input';
import {getMeasurementUnitLabel} from '../../FormBuilderScreen/shared';

function NumericFilter({question, filter, onChange, validations}) {
  const unit = getMeasurementUnitLabel(question);
  const withUnit = label => unit ? `${label} (${unit})` : label;

  return (
    <>
      <Input
        placeholder={withUnit(filter.operator === 'BETWEEN' ? 'Lower bound' : 'Value')}
        type="number"
        step="any"
        value={filter.values[0] || ''}
        onChange={e => onChange({
          ...filter, 
          values: filter.operator === 'BETWEEN' ? [e.target.value, filter.values[1]] : [e.target.value]
        })}
        invalid={validations[0]}
        validationText={validations[0]}
      />
      {filter.operator === 'BETWEEN' && (
        <StyledInput
          placeholder={withUnit('Upper bound')}
          type="number"
          step="any"
          value={filter.values[1] || ''}
          onChange={e => onChange({...filter, values: [filter.values[0], e.target.value]})}
          invalid={validations[1]}
          validationText={validations[1]}
        />
      )}
    </>
  );
}

NumericFilter.validate = filter => {
  const messages = [];

  if (filter.operator === 'BETWEEN') {
    if (!isNumber(filter.values[0])) {
      messages[0] = 'Your lower bound must be a valid number';
    }

    if (!isNumber(filter.values[1])) {
      messages[1] = 'Your upper bound must be a valid number';
    }
  }
  else if (!isNumber(filter.values[0])) {
    messages.push('Enter a valid number');
  }

  return messages;
};

NumericFilter.operators = [
  'EQUAL',
  'NOT_EQUAL',
  'GREATER_THAN',
  'GREATER_THAN_OR_EQUAL',
  'LESS_THAN',
  'LESS_THAN_OR_EQUAL',
  'BETWEEN'
];

function isNumber(str) {
  if (str === '' || str === null) {
    return false;
  }

  return !isNaN(Number(str));
}

const StyledInput = styled(Input)`
  margin-top: 0.5rem;
`;

export default NumericFilter;